import { alias, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number;
	firstName?: string;
	lastName?: string;
	email?: string;
	dialerId?: string | null;
}

export class User {
	public static fromJson(json: IJsonObject): User {
		return deserialize(User, json);
	}

	public static fromJsonArray(json: IJsonObject[]): User[] {
		return json.map((user: IJsonObject) => this.fromJson(user));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("first_name"))
	public firstName: string;

	@serializable(alias("last_name"))
	public lastName: string;

	@serializable(alias("dialer_id"))
	public dialerId: string | null;

	@serializable
	public email: string;

	get fullName() {
		return this.firstName + " " + this.lastName;
	}

	constructor({
		id = 0,
		firstName = "",
		lastName = "",
		email = "",
		dialerId = null,
	}: IProps = {}) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = email;
		this.dialerId = dialerId;
	}
}
